import styled from '@emotion/styled';

const STYLE_OPTIONS = {
  sm: {
    borderRadius: 1,
    padding: 1,
  },
  md: {
    borderRadius: 2,
    padding: 2,
  },
  lg: {
    borderRadius: 3,
    padding: 4,
  },
};

// Used for most containers which you want to "pop" out of the background
export const StyledContainer = styled.div(({ theme, size = 'md', type = 'border' }) => {
  return {
    backgroundColor: theme.palette.background.default,
    height: 'min-content',
    borderRadius: theme.shape.borderRadius * STYLE_OPTIONS[size].borderRadius,
    padding: theme.spacing(STYLE_OPTIONS[size].padding),
    ...(type === 'shadow'
      ? { boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.06)' }
      : { border: `1px solid ${theme.palette.divider}` }),
  };
});

export const StyledMenu = styled.div(({ theme }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius * 1,
  height: 'min-content',
  boxShadow: '2px 4px 8px rgba(0, 0, 0, 0.05)',
  border: `1px solid ${theme.palette.divider}`,
}));
